import { queryOptions } from '@tanstack/react-query';
import { get, toQueryString } from '@/utility/requestHelpers/clientRequestHelpers';

export type ShippingOptionsQueryParams = {
  shopId: string;
  locale: string;
  /** Comma-separated: the PDP asks for one, the volume calculator for several. */
  productTypeIds: string;
  printTypeIds: string[];
  countryIsoCode: string;
  currencyCode?: string;
  quantity: number;
  totalPrice?: number;
};

/**
 * Delivery options, prices, ETAs and free-shipping thresholds of the destination country, from
 * the unified shipping service (DEV-233737). The dialog lets the customer switch country, so this
 * runs in the browser against our own `/internal/api` proxy rather than on the server.
 */
export const getShippingOptionsQueryOptions = ({
  shopId,
  locale,
  productTypeIds,
  printTypeIds,
  countryIsoCode,
  currencyCode,
  quantity,
  totalPrice,
}: ShippingOptionsQueryParams) =>
  queryOptions({
    queryKey: [
      'shippingOptions',
      shopId,
      locale,
      productTypeIds,
      printTypeIds,
      countryIsoCode,
      currencyCode,
      quantity,
      totalPrice,
    ],
    queryFn: () =>
      get<ShippingOption[]>(
        `/internal/api/shippingOptions?${toQueryString({
          shopId,
          locale,
          productTypeIds,
          printTypeIds,
          countryIsoCode,
          currencyCode,
          quantity,
          totalPrice,
        })}`
      ),
    // The service prices by order value, so both are needed before it can be asked anything, and
    // without a country there is nothing to price for - don't guess one.
    enabled: currencyCode !== undefined && totalPrice !== undefined && !!countryIsoCode,
    placeholderData: (previousData) => previousData,
    staleTime: 60 * 60 * 1000, // 1 hour, matching the route's s-maxage
  });
